import { createSelector } from '@ngrx/store';
import { discoverFeature } from './discover.reducer';

export const selectDiscoverIndices = createSelector(discoverFeature.selectIndices, (indices) => Object.values(indices));
export const selectDiscoverIndicesKeys = createSelector(discoverFeature.selectIndices, (indices) => Object.keys(indices));
export const selectDiscoverIndicesQuoteISINs = createSelector(selectDiscoverIndices, (indices) =>
  indices.map((index) => index.historicQuote?.isin).filter((isin) => isin),
);

export const selectDiscoverTodayTeaser = createSelector(discoverFeature.selectTodayTeaser, (teaser) =>
  Object.values(teaser).sort((a, b) => (a.sort < b.sort ? -1 : 1)),
);
export const selectDiscoverTodayTeaserKeys = createSelector(discoverFeature.selectTodayTeaser, (teaser) => Object.keys(teaser));

export const selectDiscoverListAndLinks = createSelector(discoverFeature.selectListsAndLinks, (listAndLinks) =>
  Object.values(listAndLinks),
);
export const selectDiscoverListAndLinksKeys = createSelector(discoverFeature.selectListsAndLinks, (listAndLinks) =>
  Object.keys(listAndLinks),
);

export const selectDiscoverKnowHow = createSelector(discoverFeature.selectKnowHow, (knowHow) =>
  Object.values(knowHow).sort((a, b) => (a.sort < b.sort ? -1 : 1)),
);
export const selectDiscoverKnowHowKeys = createSelector(discoverFeature.selectKnowHow, (knowHow) => Object.keys(knowHow));

export const selectDiscoverMegatrends = createSelector(discoverFeature.selectMegatrends, (megatrends) =>
  Object.values(megatrends).sort((a, b) => (a.sort < b.sort ? -1 : 1)),
);
export const selectDiscoverMegatrendsKeys = createSelector(discoverFeature.selectMegatrends, (megatrends) => Object.keys(megatrends));

export const selectDiscoverTopPerformerGroups = createSelector(discoverFeature.selectTopPerformerGroups, (topPerformerGroups) =>
  topPerformerGroups
    ? Object.values(topPerformerGroups).map((group) => ({
        ...group,
        instruments: [...group.instruments].sort((a, b) => b.perfPct - a.perfPct),
      }))
    : [],
);

export const selectDiscoverTopPerformerInstrumentISINsByGroup = (groupIdentifier) =>
  createSelector(discoverFeature.selectTopPerformerGroups, (topPerformerGroups) =>
    topPerformerGroups[groupIdentifier]?.instruments.map((instrument) => instrument.isin),
  );

export const selectDiscoverDetailsInstruments = createSelector(discoverFeature.selectDetails, (details) => details.instruments);
export const selectDiscoverDetailsInstrumentISINs = createSelector(discoverFeature.selectDetails, (details) =>
  details?.instruments ? Object.keys(details.instruments) : [],
);

export const selectDiscoverListDetailsInstruments = createSelector(discoverFeature.selectListDetails, (details) =>
  details?.instruments ? Object.values(details.instruments) : [],
);
export const selectDiscoverListDetailsInstrumentISINs = createSelector(discoverFeature.selectListDetails, (details) =>
  details?.instruments ? Object.keys(details.instruments) : [],
);
